import { errorMessages } from '~/constants/errorMessages.ts';
import { DiiaFinalStatuses, DiiaStatuses } from '~/store/diia/types.ts';
import { FILES_SIGNING_DIIA_FAILURE_STATUSES } from './constants.ts';

const DIIA_FAILURE_STATUSES_SET = new Set<string>(FILES_SIGNING_DIIA_FAILURE_STATUSES);

export const isFilesSigningDiiaFailureStatus = (status?: string | null): boolean =>
  !!status && DIIA_FAILURE_STATUSES_SET.has(status);

export const canFinalizeFilesSigningDiiaStatus = (status?: string | null): boolean =>
  status === DiiaStatuses.done || status === DiiaStatuses.processing;

export const isSuccessfulFilesSigningDiiaApplyStatus = (status?: string | null): boolean =>
  !status || status === DiiaFinalStatuses.success || status === DiiaStatuses.done;

export const getFilesSigningDiiaFailureMessage = (status?: string | null): string =>
  status === DiiaStatuses.refuse
    ? errorMessages.DOCUMENT_SIGNING_REFUSED
    : errorMessages.DOCUMENT_SIGNING_FAILED;

export const getFilesSigningErrorMessage = (error: unknown): string =>
  (error as { message?: string; data?: { message?: string } } | undefined)?.message ||
  (error as { data?: { message?: string } } | undefined)?.data?.message ||
  errorMessages.SERVICE_UNAVAILABLE;
